import { useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import Accordion from "@mui/material/Accordion";
import VoyageAccordion from "../ui/VoyageAccordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Label } from "abs-ui-components";
import { Input } from "abs-ui-components";
import { preventScientificNotation } from "../../../../../../services/utilities";

const ROBForm = ({ section, type, expandedId, setExpandedId }) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const accordionRef2 = useRef(null);

	const sanitizeKey = (key) => {
		if (!key) return "";
		return key.replace(/\|/g, "").replace(/\./g, "_");
	};


	const handleAccordionFocus = (event, accordionReference) => {
		if (
			accordionReference.current &&
			event.target === accordionReference.current
		) {
			// Simulate a click to toggle the accordion
			accordionReference.current.click();
		}
	};

	return (
		<>
			{section.sectionName === "Fuel ROB" && (
				<VoyageAccordion
				 	accordionId="ROB"
    			 	expandedId={expandedId}
    				setExpandedId={setExpandedId}
					className="mt-4"
					onKeyDown={(event) => {
						if (event.key === "Tab") {
							handleAccordionFocus(event, accordionRef2);
						}
					}}
				
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel2-content"
						id="panel2-header"
						ref={accordionRef2}
					>
						<span className="voyage-form-headings">ROB</span>
					</AccordionSummary>
					<AccordionDetails>
						<MDBRow className="mt-0">
							{section?.fields?.map((formField, fieldIndex) => (
								<MDBCol
									md="3"
									className="pr-2 mt-3"
									key={`${formField.key}-${fieldIndex}`}
								>
									{formField.dataType === "decimal" && (
										<>
											<Label
												bold
												name={formField.fieldName}
												className="mb-1"
											/>
											<Controller
												name={
													sanitizeKey(formField.key)
												}
												control={control}
												defaultValue={
													type === "Edit"
														? formField.value ||
														null
														: ""
												}
												render={({ field }) => {
													// Ensure field is defined before accessing properties
													if (!field) return null; // Return null if field is undefined

													return (
														<Input
															autoFocus={false}
															{...field} // Spread the field props from Controller
															className="inputHeight"
															type="number"
															step="any"
															onChange={(e) => {
																field.onChange(
																	e
																);
															}}
															value={
																field?.value ??
																""
															} // Safely use field.value or fallback to ''
															onKeyDown={(e) => {
																preventScientificNotation(e);
																// Prevent up and down arrow keys
																if (
																	e.key === "ArrowUp" ||
																	e.key === "ArrowDown"
																) {
																	e.preventDefault();
																}
															}}
															onWheel={(e) => e.target.blur()}
														/>
													);
												}}
											/>
										</>
									)}
								</MDBCol>
							))}
						</MDBRow>
					</AccordionDetails>
				</VoyageAccordion>
			)}
		</>
	);
};

export default ROBForm;
